import { ProjectReportShort } from "@/store/admin/adminTypes";

// Team effectiveness reports published with reportVersion >= 2.0 use the v2 (tabbed) report.
// Older reports keep rendering with the original component so existing publishes are unaffected.
export function isTeamEffectivenessV2(version: string | undefined): boolean {
  return parseInt((version ?? "1.0").split(".")[0], 10) >= 2;
}

export function getProjectReportLink(report: Pick<ProjectReportShort, "identifier" | "type" | "version">): string {
  switch (report.type) {
    case "team-effectiveness":
      return isTeamEffectivenessV2(report.version) ? `/admin/team-effectiveness-report-v2/${report.identifier}` : `/admin/team-effectiveness-report/${report.identifier}`;
    case "search-report":
      return `/admin/search-report/${report.identifier}`;
    default:
      return `/admin/evaluation-report/${report.identifier}`;
  }
}
